import { render } from "./Products.vue?vue&type=template&id=0789856c"
const script = {}
script.render = render

export default script